import { useMemo } from "react";
import { useGetIntentBuyersJourneyQuery } from "@/generated/taxonomy";
import { TAXONOMY_CLIENT } from "@/utils/consts";
import { useSelectionLabel } from "./useSelectionLabel";

export const useBuyersJourneyLabel = (selectedIds: string[]): string => {
  const { data } = useGetIntentBuyersJourneyQuery({
    context: { clientName: TAXONOMY_CLIENT },
  });

  const options = useMemo(() => data?.intentBuyersJourney?.data ?? [], [data]);

  return useSelectionLabel(selectedIds, options);
};
